import Fashor from './Fashor.webp';
import ForteDeAzure from './Forte de Azure.webp';
import FogCity from './Map.webp';
import Oblador from './Oblador.webp';
import ObladorFlag from './ObladorFlag.webp';
import Pyramid from './Pyramid.webp';
import Redwatch from './Redwatch_Labels.webp';
import ShingleWood from './Shingle Wood.webp';
import Tario from './Tario.webp';
import TrainingArmory from './The Training Armory.webp';
import TrainingGrounds from './Training Grounds.webp';
import WayfinderAirlock from './Wayfinder - Airlock Chamber.webp';
import WayfinderBridge from './Wayfinder - Main Bridge.webp';
import WayfinderElectrical from './Wayfinder - Electrical Maintenance2.webp';
import WayfinderReactor from './Wayfinder - Reactor Chamber.webp';

export default {
    Fashor,
    ForteDeAzure,
    FogCity,
    Oblador,
    ObladorFlag,
    Pyramid,
    Redwatch,
    ShingleWood,
    Tario,
    TrainingArmory,
    TrainingGrounds,
    WayfinderAirlock,
    WayfinderBridge,
    WayfinderElectrical,
    WayfinderReactor
}